import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";

import Navbar from "./components/Navbar.jsx";
import Footer from "./components/Footer.jsx";
import WhatsAppFloat from "./components/WhatsAppFloat.jsx";
import EnquiryPopup from "./components/EnquiryPopup.jsx";
import QuotationTicker from "./pages/QuotationTicker.jsx"; // ✅ ADD THIS

import Home from "./pages/Home.jsx";
import AboutVVCMS from "./pages/AboutVVCMS.jsx";
import InsideVVCMS from "./pages/InsideVVCMS.jsx";
import LearningEdge from "./pages/LearningEdge.jsx";
import InnovationInfra from "./pages/InnovationInfra.jsx";
import Admissions from "./pages/Admissions.jsx";
import LifeBeyond from "./pages/LifeBeyond.jsx";
import ParentConnect from "./pages/ParentConnect.jsx";
import SpotlightMedia from "./pages/SpotlightMedia.jsx";
import SupportDesk from "./pages/SupportDesk.jsx";
import SportsArena from "./pages/SportsArena.jsx";
import VVES from "./pages/vves.jsx";
import MandatoryDisclosure from "./pages/MandatoryDisclosure.jsx";

import AOS from "aos";
import "aos/dist/aos.css";

/* ------------------------------
   SCROLL TO TOP
------------------------------ */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

/* ------------------------------
   APP CONTENT
------------------------------ */
const AppContent = () => {
  const [showEnquiry, setShowEnquiry] = useState(false);

  const sectionsRef = {
    home: useRef(null),
    about: useRef(null),
  };

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out",
    });
  }, []);

  const scrollToSection = (key) => {
    const el = sectionsRef[key]?.current;
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  /* ------------------------------
     NAV HANDLER
  ------------------------------ */
  const handleNavClick = (key) => {
    if (key === "vves") return navigate("/vves");
    if (key === "inside") return navigate("/inside-vvcms");
    if (key === "learning") return navigate("/learning-edge");
    if (key === "innovation") return navigate("/innovation-infra");
    if (key === "life") return navigate("/life-beyond");
    if (key === "parents") return navigate("/parent-connect");
    if (key === "spotlight") return navigate("/spotlight-media");
    if (key === "admissions") return navigate("/admissions");
    if (key === "support") return navigate("/support-desk");
    if (key === "sports") return navigate("/sports-arena");
    if (key === "disclosure") return navigate("/mandatory-disclosure");

    const targetKey = key === "home" ? "home" : key;

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToSection(targetKey), 50);
    } else {
      scrollToSection(targetKey);
    }
  };

  /* ------------------------------
     SHARED PAGE WRAPPER
  ------------------------------ */
  const PageWrapper = ({ children }) => (
    <>
      <Navbar onNavClick={handleNavClick} />
      <main style={{ marginTop: "120px" }}>{children}</main>

      {/* ✅ QUOTATION TICKER ABOVE FOOTER */}
      <QuotationTicker />

      <Footer />
      <WhatsAppFloat phoneNumber="918977753424" />
    </>
  );

  return (
    <>
      <ScrollToTop />

      <Routes>
        {/* HOME PAGE */}
        <Route
          path="/"
          element={
            <>
              <Navbar onNavClick={handleNavClick} />
              <main>
                <section ref={sectionsRef.home}>
                  <Home />
                </section>

                <section ref={sectionsRef.about}>
                  <AboutVVCMS />
                </section>
              </main>

              {/* ✅ QUOTATION TICKER ABOVE FOOTER */}
              <QuotationTicker />

              <Footer />
              <WhatsAppFloat phoneNumber="918977753424" />
            </>
          }
        />

        {/* OTHER PAGES */}
        <Route path="/vves" element={<PageWrapper><VVES /></PageWrapper>} />
        <Route path="/inside-vvcms" element={<PageWrapper><InsideVVCMS /></PageWrapper>} />
        <Route path="/learning-edge" element={<PageWrapper><LearningEdge /></PageWrapper>} />
        <Route path="/innovation-infra" element={<PageWrapper><InnovationInfra /></PageWrapper>} />
        <Route path="/life-beyond" element={<PageWrapper><LifeBeyond /></PageWrapper>} />
        <Route path="/parent-connect" element={<PageWrapper><ParentConnect /></PageWrapper>} />
        <Route path="/spotlight-media" element={<PageWrapper><SpotlightMedia /></PageWrapper>} />
        <Route
          path="/admissions"
          element={
            <PageWrapper>
              <Admissions onEnquiryClick={() => setShowEnquiry(true)} />
            </PageWrapper>
          }
        />
        <Route path="/support-desk" element={<PageWrapper><SupportDesk /></PageWrapper>} />
        <Route path="/sports-arena" element={<PageWrapper><SportsArena /></PageWrapper>} />
        <Route path="/mandatory-disclosure" element={<PageWrapper><MandatoryDisclosure /></PageWrapper>} />
      </Routes>

      {showEnquiry && <EnquiryPopup onClose={() => setShowEnquiry(false)} />}
    </>
  );
};

/* ------------------------------
   OUTER APP
------------------------------ */
const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
